import { store } from "../redux/store";

class ClientAuthContext {
  constructor() {
    this.token = '';
  }

  setToken(token) {
    this.token = token;
  }

  getToken() {
    return this.token || store.getState().User.token;
  }

  resetToken() {
    this.token = '';
  }
}

export const clientAuthContext = new ClientAuthContext();